import { TrainerToolsProvider } from '../provider';
import TrainerToolsView from './TrainerToolsView';
import DashboardWebsocket from './DashboardWebsocket';

const TrainerTools = () => {
  return (
    <TrainerToolsProvider>
      <TrainerToolsView />
      <DashboardWebsocket />
    </TrainerToolsProvider>
  );
};

export default TrainerTools;
